import { render, staticRenderFns } from "./ser_kejin.vue?vue&type=template&id=0049982a&scoped=true&"
import script from "./ser_kejin.vue?vue&type=script&lang=js&"
export * from "./ser_kejin.vue?vue&type=script&lang=js&"
import style0 from "./ser_kejin.vue?vue&type=style&index=0&id=0049982a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049982a",
  null
  
)

export default component.exports